import { ComplianceEntity } from "@wingspanhq/wingspan-api-sdk";
import { FormPartialDataUsPersonInfo } from "../FormPartialUsPersonInfo";

/**
 * The US-person names are stored as the entity's individual legal name, so they
 * prefill from there. The date the person became a US person has no field on the
 * entity, so the "when" answer falls back to the form's default.
 */
export const getUsPersonData = (
  entity: ComplianceEntity | undefined
): Partial<FormPartialDataUsPersonInfo> => ({
  firstName: entity?.individualLegalName?.givenName,
  middleName: entity?.individualLegalName?.middleNames,
  lastName: entity?.individualLegalName?.familyName
});
